module.exports = __webpack_public_path__ + "static/media/discord-fr.e9dd4949.webp";